import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module';
import ApiFactory from '@/api/apiFactory';

const ContentRepository = ApiFactory.get('content');

const fillValue = (state: any, newValue: Record<string, any>) => {
  Object.keys(state).forEach((stateValue: string) => {
    switch (typeof stateValue) {
      case 'string': {
        state[stateValue] = newValue[stateValue] && newValue[stateValue].length ? newValue[stateValue] : '';
        break;
      }
      case 'object': {
        if (Array.isArray(stateValue)) {
          // eslint-disable-next-line no-param-reassign
          state[stateValue] = newValue[stateValue] && newValue[stateValue].length ? newValue[stateValue] : [];
        } else {
          // eslint-disable-next-line no-param-reassign
          state[stateValue] = newValue[stateValue] && Object.keys(newValue[stateValue]).length ? newValue[stateValue] : {};
        }
        break;
      }
      default: {
        // eslint-disable-next-line no-param-reassign
        state[stateValue] = newValue[stateValue];
      }
    }
  });
};

interface Content {
  content?: string;
  header?: string;
  updated?: string;
  version?: string;
  notes?: [];
  relatedArticles?: [];
  tooltips?: [];
}

class ContentState {
  data: Content = {
    content: '',
    header: '',
    notes: [],
    relatedArticles: [],
    tooltips: [],
    updated: '',
    version: '',
  };

  onLoad = false;

  onError = false;

  redirectUrl = '';
}

class ContentGetters extends Getters<ContentState> {
  get content() {
    if (this.state.data.content !== null) {
      // @ts-ignore
      if (this.state.data.content.indexOf('id="payments_options') === -1) {
        return this.state.data.content;
      }
    }
    return this.state.data.content;
  }
}

class ContentMutations extends Mutations<ContentState> {
  setOnLoad(state: boolean) {
    this.state.onLoad = state;
  }

  setOnError(state: boolean) {
    this.state.onError = state;
  }

  clearValues() {
    this.state.redirectUrl = '';
    fillValue(this.state.data, {});
  }

  setValues(payload: ContentState) {
    fillValue(this.state.data, payload);
  }

  setRedirectUrl(url: string) {
    this.state.redirectUrl = url;
  }
}

class ContentActions extends Actions<
  ContentState,
  ContentGetters,
  ContentMutations,
  ContentActions
> {
  async preloadPage(payload: any): Promise<boolean> {
    this.commit('clearValues');
    let check = true;
    this.commit('setOnLoad', true);
    this.commit('setOnError', false);
    try {
      const result = await ContentRepository.get(payload.locale, payload.url);
      this.commit('setValues', result);
    } catch (error) {
      if (error.response.status === 301) {
        this.commit('setRedirectUrl', error.response.data.redirectUrl);
      } else {
        this.commit('setOnError', true);
      }
      check = false;
    }
    this.commit('setOnLoad', false);
    return check;
  }
}

// Экспорт модуля
export const ContentModule = new Module({
  state: ContentState,
  getters: ContentGetters,
  mutations: ContentMutations,
  actions: ContentActions,
});

export const ContentModuleMapper = createMapper(ContentModule);
